module.exports = "<widget [size]=\"[1,1]\" [last]=\"last\">\n  <div class=\"content\" widget-content>\n    <div class=\"widget-data\">{{ data }}</div>\n    <div class=\"widget-title\" translate>Visits Today</div>\n  </div>\n</widget>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/visits-today/visits-today.component.html
// module id = ./src/app/widgets/visits-today/visits-today.component.html
// module chunks = main